import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import style from "./Events.module.css";
import CardMedia from "@mui/material/CardMedia";
import { GoOrganization } from "react-icons/go";
import { FaRegCalendar } from "react-icons/fa6";
import { IoArrowBack } from "react-icons/io5";
import { baseurl } from "../Url";

function Events() {
  const navigate = useNavigate();
  const [eventsData, setEventsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${baseurl}/events/list`);
        const data = await response.json();

        // Sort events by created_date in descending order
        const sortedEvents = data.data.sort((a, b) => {
          return b.created_date.$date - a.created_date.$date;
        });

        setEventsData(sortedEvents);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleMoreClick = (eventId, eventName) => {
    localStorage.setItem("eventId", eventId);
    localStorage.setItem("eventName", eventName);
    navigate("/event/details");
  };

  return (
    <div className={style.container}>
      <div className={style.header}>
        <div className={style.headerText}>
          <button className={style.backButton} onClick={() => navigate(-1)}>
            <IoArrowBack />
          </button>
          <p>Duno Events</p>
        </div>
      </div>

      <div className={style.eventCardsBox}>
        {eventsData.map((event) => (
          <div
            className={style.eventCards}
            key={event.event_id}
            onClick={() => handleMoreClick(event.event_id, event.event_title)}
          >
            <div className={style.cardContainer}>
              <CardMedia
                className={style.cardImage}
                sx={{ height: 200 }}
                image={event.event_image}
              />

              <div className={style.CardContent}>
                <div className={style.eventTitle}>
                  <h2>{event.event_title}</h2>
                </div>

                <div className={style.host}>
                  <GoOrganization />
                  <p> Hosted By: {event.host_name}</p>
                </div>

                <div className={style.date}>
                  <FaRegCalendar />
                  <p>
                    Date:{" "}
                    <span>
                      {new Date(event.event_start_date.$date).toDateString()}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Events;
